// Calendar provider identifiers — part of the OAuth initiate URL surface.
export type CalendarProvider = "google" | "outlook";

export const CALENDAR_PROVIDERS = {
	GOOGLE: "google",
	OUTLOOK: "outlook",
} as const;

// Mirrors server-side `VideoConferencingProviderEnum`.
export type VideoConferencingProvider = "zoom";

export const VIDEO_CONFERENCING_PROVIDERS = {
	ZOOM: "zoom",
} as const;

// Fallback display names for toast messaging when only the identifier is available.
export const VIDEO_CONFERENCING_PROVIDER_DISPLAY_NAMES: Record<VideoConferencingProvider, string> = {
	zoom: "Zoom",
};

export const CALENDAR_PROVIDER_DISPLAY_NAMES: Record<CalendarProvider, string> = {
	google: "Google Calendar",
	outlook: "Outlook Calendar",
};
